import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=1b98be04&scoped=true"
import script from "./editQuestion.vue?vue&type=script&lang=js"
export * from "./editQuestion.vue?vue&type=script&lang=js"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=1b98be04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98be04",
  null
  
)

export default component.exports